/* ArtSight hero gallery: the artworks take turns in one frame, the next one coming into focus over the last.
   The first slide is in the markup, so without JavaScript the frame simply shows that artwork. */
(function () {
  if (window.asHeroGalleryLoaded) return;
  window.asHeroGalleryLoaded = true;

  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function list(root, selector) {
    return Array.prototype.slice.call(root.querySelectorAll(selector));
  }

  function init(root) {
    if (!root || root.dataset.asHeroInit) return;
    var slides = list(root, '.as-hero__slide');
    if (slides.length < 2) return; // one artwork: a still frame, no lines, no controls
    root.dataset.asHeroInit = '1';

    var stage = root.querySelector('[data-stage]');
    var frame = root.querySelector('.as-hero__frame');
    var tickRow = root.querySelector('.as-hero__ticks');
    var caps = list(root, '.as-hero__caption');
    var ticks = list(root, '.as-hero__tick');
    var playBtn = root.querySelector('[data-play]');
    var editor = !!(window.Shopify && window.Shopify.designMode);
    var cur = 0;
    var seq = 0;
    // auto: plays, and waits while the pointer or the keyboard is on the frame.
    // stopped: stays put, after the visitor chose a slide or pressed pause. play: the visitor asked for it back.
    var mode = reduce || editor || root.dataset.autoplay === 'false' ? 'stopped' : 'auto';
    var hovered = false;
    var focused = false;
    var inView = true;
    var swiped = false;
    var downX = null;
    var downY = 0;

    function sync() {
      var stopped = mode === 'stopped';
      var run = !stopped && inView && !document.hidden && (mode === 'play' || (!hovered && !focused));
      root.classList.toggle('is-auto', !stopped);
      root.classList.toggle('is-paused', !run);
      stage.setAttribute('aria-live', stopped ? 'polite' : 'off');
      playBtn.classList.toggle('is-stopped', stopped);
      playBtn.setAttribute('aria-label', stopped ? 'Play the slideshow' : 'Pause the slideshow');
    }

    function show(n) {
      n = (n + slides.length) % slides.length;
      if (n === cur) return;
      var prev = cur;
      cur = n;
      slides.forEach(function (s, i) {
        s.classList.remove('is-entering', 'is-leaving');
        s.classList.toggle('is-active', i === cur);
      });
      if (!reduce) {
        slides[prev].classList.add('is-leaving');
        void slides[cur].offsetWidth; // lets the animation start again on a slide that was still in transition
        slides[cur].classList.add('is-entering');
      }
      caps.forEach(function (c, i) {
        c.classList.toggle('is-active', i === cur);
      });
      ticks.forEach(function (t, i) {
        t.classList.toggle('is-active', i === cur);
        if (i === cur) t.setAttribute('aria-current', 'true');
        else t.removeAttribute('aria-current');
      });
    }

    function byHand(n) {
      seq++;
      mode = 'stopped';
      show(n);
      sync();
    }

    // Autoplay waits for the next photograph to load, four seconds at most, so a slow connection never shows an empty frame for long.
    function whenLoaded(slide, done) {
      var img = slide.querySelector('img');
      if (!img || img.complete) {
        done();
        return;
      }
      var called = false;
      function go() {
        if (called) return;
        called = true;
        done();
      }
      img.addEventListener('load', go, { once: true });
      img.addEventListener('error', go, { once: true });
      setTimeout(go, 4000);
    }

    // The clock is the line filling under the frame: when it is full, the next photograph is called.
    tickRow.addEventListener('animationend', function (e) {
      if (e.animationName !== 'as-hero-tick') return;
      var next = (cur + 1) % slides.length;
      var ticket = ++seq;
      whenLoaded(slides[next], function () {
        if (ticket === seq) show(next);
      });
    });
    stage.addEventListener('animationend', function (e) {
      if (e.animationName !== 'as-hero-focus-in') return;
      slides.forEach(function (s) {
        s.classList.remove('is-entering', 'is-leaving');
      });
    });

    root.querySelector('[data-prev]').addEventListener('click', function () {
      byHand(cur - 1);
    });
    root.querySelector('[data-next]').addEventListener('click', function () {
      byHand(cur + 1);
    });
    ticks.forEach(function (t, i) {
      t.addEventListener('click', function () {
        byHand(i);
      });
    });
    playBtn.addEventListener('click', function () {
      seq++;
      mode = mode === 'stopped' ? 'play' : 'stopped';
      sync();
    });
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
      e.preventDefault();
      byHand(cur + (e.key === 'ArrowRight' ? 1 : -1));
    });

    frame.addEventListener('pointerenter', function (e) {
      if (e.pointerType !== 'mouse') return;
      hovered = true;
      sync();
    });
    frame.addEventListener('pointerleave', function () {
      hovered = false;
      sync();
    });
    root.addEventListener('focusin', function (e) {
      try {
        focused = e.target.matches(':focus-visible');
      } catch (err) {
        focused = true;
      }
      sync();
    });
    root.addEventListener('focusout', function (e) {
      if (root.contains(e.relatedTarget)) return;
      focused = false;
      sync();
    });

    // Swipe left or right on the photograph. Vertical movement is left to the page scroll.
    stage.addEventListener('pointerdown', function (e) {
      downX = e.clientX;
      downY = e.clientY;
      swiped = false;
    });
    stage.addEventListener('pointerup', function (e) {
      if (downX === null) return;
      var dx = e.clientX - downX;
      var dy = e.clientY - downY;
      downX = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy) * 1.5) {
        swiped = true;
        byHand(cur + (dx < 0 ? 1 : -1));
      }
    });
    stage.addEventListener('pointercancel', function () {
      downX = null;
    });
    stage.addEventListener(
      'click',
      function (e) {
        if (!swiped) return;
        e.preventDefault();
        swiped = false;
      },
      true
    );

    // No turning while the frame is off screen or the tab is in the background.
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          inView = entries[entries.length - 1].isIntersecting;
          sync();
        },
        { threshold: 0.3 }
      ).observe(frame);
    }
    document.addEventListener('visibilitychange', sync);

    root.asHeroShow = byHand; // used by the Theme Editor when an artwork block is selected
    root.classList.add('is-ready');
    sync();
  }

  function boot() {
    list(document, '[data-as-hero]').forEach(init);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  // Theme Editor: start again after a section reload, and show the artwork whose block is selected.
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-as-hero]');
    if (!root) return;
    delete root.dataset.asHeroInit;
    init(root);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.as-hero__slide');
    var root = slide && slide.closest('[data-as-hero]');
    if (!root || !root.asHeroShow) return;
    root.asHeroShow(list(root, '.as-hero__slide').indexOf(slide));
  });
})();
